import { TipoProfiloSede, userInfoSelector } from 'pages/admin/_redux/selectors';
import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from 'store/hooks';
import logoPiccolo from '../../assets/images/banco-di-desio-squarelogo.png';
import logoGrande from '../../assets/images/Logo_Banco_Desio.png';

interface MenuItem {
  key: string
  to: string
  label: string
  icon: string
  roles?: string[]
}

const menu: MenuItem[] = [
  {
    key: 'dashboard',
    to: '/admin/dashboard',
    label: 'Dashboard',
    icon: 'fas fa-tachometer-alt'
  },
  {
    key: 'dashboard-campagne',
    to: '/admin/cruscotto-campagne',
    label: 'Dashboard campagne',
    icon: 'fas fa-tachometer-alt',
    roles: [TipoProfiloSede]
  },
  {
    key: 'ricerca-anagrafe-cedacri',
    to: '/admin/ricerca-anagrafe-cedacri',
    label: 'Anagrafe Cedacri',
    icon: 'fas fa-table'
  }, {
    key: 'ricerca',
    to: '/admin/ricerca',
    label: 'Ricerca',
    icon: 'fas fa-search'
  },
  {
    key: 'campagne',
    to: '/admin/campagne',
    label: 'Campagne',
    icon: 'fas fa-users',
    roles: [TipoProfiloSede]
  }
];

const Sidebar: React.FC = () => {

  const { pathname } = useLocation();
  const userInfo = useAppSelector(userInfoSelector);

  /* MODIFICATO IL REDIRECT DI VAI AL DETTAGLIO NELLA DASHBOARD IN RICERCA E AGGIUNTA UNA NUOVA ROUTE */
  //let logoCompleto = window.screen.width > 767 ? logoDesio : '../../assets/images/Logo_Banco_Desio.png'
  return (

    <div className="sidebar">
      <div className="logo-container">
        {/* <img alt="Logo Desio" className={pageWidth >= 767 ? "imgLogoGrande" : "imgLogo"} src={pageWidth >= 767 ? logoGrande : logoPiccolo} /> */}
        <img alt="Logo Desio" className="img-logo-big d-none d-md-block" src={logoGrande} />
        <img alt="Logo Desio" className="img-logo-small d-block d-md-none" src={logoPiccolo} />
      </div>
      <Nav activeKey={menu.find(item => pathname.startsWith(item.to))?.key} className="flex-column">
        {menu.filter(m => !m.roles || m.roles.some(r => r === userInfo?.tipoProfilo)).map((menuItem) => (
          <Nav.Link key={menuItem.key} eventKey={menuItem.key} as={Link} to={menuItem.to} id={menuItem.key}>
            <i className={`${menuItem.icon} pr-2`}></i>
            {menuItem.label}
          </Nav.Link>
        ))}
      </Nav>
    </div>

  );
}


export default Sidebar;
